// Records which checkout layout this shopper will get in the `_cc_screen` cart
// attribute: "narrow" (one column, below 1000px) or "wide" (two columns).
// James Oro's checkout blocks read it to choose the phone or desktop placement;
// a block's own slot width can't tell the two apart.
(function (root) {
  const ATTRIBUTE = '_cc_screen';
  const BREAKPOINT_PX = 1000;
  const script = document.currentScript;
  // Keep the page's original fetch: this write changes no line items, so cart
  // observers that wrap fetch later have nothing to react to.
  const send = root.fetch.bind(root);
  const cartRoot = root.Shopify?.routes?.root || '/';
  let recorded = script?.dataset.current || '';
  let pending = '';

  function layout() {
    return root.innerWidth < BREAKPOINT_PX ? 'narrow' : 'wide';
  }

  function record() {
    const value = layout();
    if (value === recorded || value === pending) return;
    pending = value;
    send(`${cartRoot}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTRIBUTE]: value } }),
      keepalive: true,
    })
      .then((response) => { if (response.ok) recorded = value; })
      .catch(() => {})
      .finally(() => {
        pending = '';
        // The window may have crossed the breakpoint while the write was in flight.
        if (recorded === value) record();
      });
  }

  record();
  const query = root.matchMedia?.(`(min-width: ${BREAKPOINT_PX}px)`);
  query?.addEventListener?.('change', record);
})(window);
